/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiClassEnrollmentsRecentStatusChangesGetDaysParameter,
  ApiUserTasksGetLastSelectedIdParameter,
  ApiUserTasksGetPageParameter,
  CreateBulkEnrollmentRequest,
  CreateBulkEnrollmentResponse,
  DropEnrollmentRequest,
  ForceClassBulkEnrollmentRequest,
  GetEnrollmentResponse,
  PaginatedResultOfGetEnrollmentResponse,
  ParentEnrollmentReviewConflict,
  ParentEnrollmentReviewItem,
  ProblemDetails,
  RecentEnrollmentStatusChangeItem,
  Result,
  StaffReviewConflict,
} from '../models/index';
import {
    ApiClassEnrollmentsRecentStatusChangesGetDaysParameterFromJSON,
    ApiClassEnrollmentsRecentStatusChangesGetDaysParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    CreateBulkEnrollmentRequestFromJSON,
    CreateBulkEnrollmentRequestToJSON,
    CreateBulkEnrollmentResponseFromJSON,
    CreateBulkEnrollmentResponseToJSON,
    DropEnrollmentRequestFromJSON,
    DropEnrollmentRequestToJSON,
    ForceClassBulkEnrollmentRequestFromJSON,
    ForceClassBulkEnrollmentRequestToJSON,
    GetEnrollmentResponseFromJSON,
    GetEnrollmentResponseToJSON,
    PaginatedResultOfGetEnrollmentResponseFromJSON,
    PaginatedResultOfGetEnrollmentResponseToJSON,
    ParentEnrollmentReviewConflictFromJSON,
    ParentEnrollmentReviewConflictToJSON,
    ParentEnrollmentReviewItemFromJSON,
    ParentEnrollmentReviewItemToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    RecentEnrollmentStatusChangeItemFromJSON,
    RecentEnrollmentStatusChangeItemToJSON,
    ResultFromJSON,
    ResultToJSON,
    StaffReviewConflictFromJSON,
    StaffReviewConflictToJSON,
} from '../models/index';

export interface ApiClassEnrollmentsActivitiesActivityIdReviewDeleteRequest {
    activityId: number;
    xTenantID?: number;
}

export interface ApiClassEnrollmentsActivitiesActivityIdReviewPutRequest {
    activityId: number;
    xTenantID?: number;
}

export interface ApiClassEnrollmentsBulkPostRequest {
    createBulkEnrollmentRequest: CreateBulkEnrollmentRequest;
    xTenantID?: number;
}

export interface ApiClassEnrollmentsClassesIdGetRequest {
    id: number;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiClassEnrollmentsForceBulkPostRequest {
    forceClassBulkEnrollmentRequest: ForceClassBulkEnrollmentRequest;
    xTenantID?: number;
}

export interface ApiClassEnrollmentsIdApprovePutRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiClassEnrollmentsIdCancelPutRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiClassEnrollmentsIdCancelScheduledDropPutRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiClassEnrollmentsIdCompletePutRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiClassEnrollmentsIdDropPutRequest {
    id: number;
    dropEnrollmentRequest: DropEnrollmentRequest;
    xTenantID?: number;
}

export interface ApiClassEnrollmentsIdProcessingTaskGetRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiClassEnrollmentsIdRejectPutRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiClassEnrollmentsIdReviewPresenceDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiClassEnrollmentsIdReviewPresencePutRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiClassEnrollmentsIdScheduledDropPutRequest {
    id: number;
    xTenantID?: number;
    dropEnrollmentRequest?: DropEnrollmentRequest;
}

export interface ApiClassEnrollmentsParentReviewsGetRequest {
    state?: string;
    xTenantID?: number;
}

export interface ApiClassEnrollmentsRecentStatusChangesGetRequest {
    days?: ApiClassEnrollmentsRecentStatusChangesGetDaysParameter;
    xTenantID?: number;
}

export interface ApiClassEnrollmentsScrollGetRequest {
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiClassEnrollmentsStudentsGetRequest {
    ids?: Array<ApiUserTasksGetPageParameter>;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiClassEnrollmentsStudentsIdGetRequest {
    id: number;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface GetEnrollmentByIdRequest {
    id: number;
    xTenantID?: number;
}

/**
 * 
 */
export class ClassEnrollmentsApi extends runtime.BaseAPI {

    /**
     * Undo parent enrollment review (short window)
     */
    async apiClassEnrollmentsActivitiesActivityIdReviewDeleteRaw(requestParameters: ApiClassEnrollmentsActivitiesActivityIdReviewDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['activityId'] == null) {
            throw new runtime.RequiredError(
                'activityId',
                'Required parameter "activityId" was null or undefined when calling apiClassEnrollmentsActivitiesActivityIdReviewDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/activities/{activityId}/review`;
        urlPath = urlPath.replace(`{${"activityId"}}`, encodeURIComponent(String(requestParameters['activityId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Undo parent enrollment review (short window)
     */
    async apiClassEnrollmentsActivitiesActivityIdReviewDelete(requestParameters: ApiClassEnrollmentsActivitiesActivityIdReviewDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiClassEnrollmentsActivitiesActivityIdReviewDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Mark parent enrollment review done
     */
    async apiClassEnrollmentsActivitiesActivityIdReviewPutRaw(requestParameters: ApiClassEnrollmentsActivitiesActivityIdReviewPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ParentEnrollmentReviewItem>> {
        if (requestParameters['activityId'] == null) {
            throw new runtime.RequiredError(
                'activityId',
                'Required parameter "activityId" was null or undefined when calling apiClassEnrollmentsActivitiesActivityIdReviewPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/activities/{activityId}/review`;
        urlPath = urlPath.replace(`{${"activityId"}}`, encodeURIComponent(String(requestParameters['activityId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParentEnrollmentReviewItemFromJSON(jsonValue));
    }

    /**
     * Mark parent enrollment review done
     */
    async apiClassEnrollmentsActivitiesActivityIdReviewPut(requestParameters: ApiClassEnrollmentsActivitiesActivityIdReviewPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ParentEnrollmentReviewItem> {
        const response = await this.apiClassEnrollmentsActivitiesActivityIdReviewPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enroll in multiple classes at once
     * Enroll in multiple classes
     */
    async apiClassEnrollmentsBulkPostRaw(requestParameters: ApiClassEnrollmentsBulkPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateBulkEnrollmentResponse>> {
        if (requestParameters['createBulkEnrollmentRequest'] == null) {
            throw new runtime.RequiredError(
                'createBulkEnrollmentRequest',
                'Required parameter "createBulkEnrollmentRequest" was null or undefined when calling apiClassEnrollmentsBulkPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/bulk`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBulkEnrollmentRequestToJSON(requestParameters['createBulkEnrollmentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateBulkEnrollmentResponseFromJSON(jsonValue));
    }

    /**
     * Enroll in multiple classes at once
     * Enroll in multiple classes
     */
    async apiClassEnrollmentsBulkPost(requestParameters: ApiClassEnrollmentsBulkPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateBulkEnrollmentResponse> {
        const response = await this.apiClassEnrollmentsBulkPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get enrollments for a class
     * Get enrollments by Class
     */
    async apiClassEnrollmentsClassesIdGetRaw(requestParameters: ApiClassEnrollmentsClassesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetEnrollmentResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiClassEnrollmentsClassesIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/classes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetEnrollmentResponseFromJSON(jsonValue));
    }

    /**
     * Get enrollments for a class
     * Get enrollments by Class
     */
    async apiClassEnrollmentsClassesIdGet(requestParameters: ApiClassEnrollmentsClassesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetEnrollmentResponse> {
        const response = await this.apiClassEnrollmentsClassesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Forces multiple students to enroll in a class in a single request, bypassing the standard enrollment validation rules
     * Force multiple student enrollments
     */
    async apiClassEnrollmentsForceBulkPostRaw(requestParameters: ApiClassEnrollmentsForceBulkPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['forceClassBulkEnrollmentRequest'] == null) {
            throw new runtime.RequiredError(
                'forceClassBulkEnrollmentRequest',
                'Required parameter "forceClassBulkEnrollmentRequest" was null or undefined when calling apiClassEnrollmentsForceBulkPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/force-bulk`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ForceClassBulkEnrollmentRequestToJSON(requestParameters['forceClassBulkEnrollmentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Forces multiple students to enroll in a class in a single request, bypassing the standard enrollment validation rules
     * Force multiple student enrollments
     */
    async apiClassEnrollmentsForceBulkPost(requestParameters: ApiClassEnrollmentsForceBulkPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiClassEnrollmentsForceBulkPostRaw(requestParameters, initOverrides);
    }

    /**
     * Marks a specific enrollment as approved by an administrator.
     * Approve a pending enrollment
     */
    async apiClassEnrollmentsIdApprovePutRaw(requestParameters: ApiClassEnrollmentsIdApprovePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiClassEnrollmentsIdApprovePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/{id}/approve`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Marks a specific enrollment as approved by an administrator.
     * Approve a pending enrollment
     */
    async apiClassEnrollmentsIdApprovePut(requestParameters: ApiClassEnrollmentsIdApprovePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiClassEnrollmentsIdApprovePutRaw(requestParameters, initOverrides);
    }

    /**
     * Allows a parent or student to cancel an existing enrollment before the associated class session begins.
     * Cancel an existing enrollment
     */
    async apiClassEnrollmentsIdCancelPutRaw(requestParameters: ApiClassEnrollmentsIdCancelPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiClassEnrollmentsIdCancelPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/{id}/cancel`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Allows a parent or student to cancel an existing enrollment before the associated class session begins.
     * Cancel an existing enrollment
     */
    async apiClassEnrollmentsIdCancelPut(requestParameters: ApiClassEnrollmentsIdCancelPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiClassEnrollmentsIdCancelPutRaw(requestParameters, initOverrides);
    }

    /**
     * Cancels a parent withdrawal request, or an admin withdrawal whose effective date is still after the studio\'s current day. The student stays enrolled.
     * Cancel a withdrawal that has not taken effect
     */
    async apiClassEnrollmentsIdCancelScheduledDropPutRaw(requestParameters: ApiClassEnrollmentsIdCancelScheduledDropPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiClassEnrollmentsIdCancelScheduledDropPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/{id}/cancel-scheduled-drop`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancels a parent withdrawal request, or an admin withdrawal whose effective date is still after the studio\'s current day. The student stays enrolled.
     * Cancel a withdrawal that has not taken effect
     */
    async apiClassEnrollmentsIdCancelScheduledDropPut(requestParameters: ApiClassEnrollmentsIdCancelScheduledDropPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiClassEnrollmentsIdCancelScheduledDropPutRaw(requestParameters, initOverrides);
    }

    /**
     * Used by administrators or the system to mark an enrollment as completed once the associated class or course has ended.
     * Mark an enrollment as completed
     */
    async apiClassEnrollmentsIdCompletePutRaw(requestParameters: ApiClassEnrollmentsIdCompletePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiClassEnrollmentsIdCompletePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/{id}/complete`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by administrators or the system to mark an enrollment as completed once the associated class or course has ended.
     * Mark an enrollment as completed
     */
    async apiClassEnrollmentsIdCompletePut(requestParameters: ApiClassEnrollmentsIdCompletePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiClassEnrollmentsIdCompletePutRaw(requestParameters, initOverrides);
    }

    /**
     * Allows a parent, student, or administrator to drop an enrollment after the class has started.
     * Drop an active enrollment
     */
    async apiClassEnrollmentsIdDropPutRaw(requestParameters: ApiClassEnrollmentsIdDropPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiClassEnrollmentsIdDropPut().'
            );
        }

        if (requestParameters['dropEnrollmentRequest'] == null) {
            throw new runtime.RequiredError(
                'dropEnrollmentRequest',
                'Required parameter "dropEnrollmentRequest" was null or undefined when calling apiClassEnrollmentsIdDropPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/{id}/drop`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DropEnrollmentRequestToJSON(requestParameters['dropEnrollmentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Allows a parent, student, or administrator to drop an enrollment after the class has started.
     * Drop an active enrollment
     */
    async apiClassEnrollmentsIdDropPut(requestParameters: ApiClassEnrollmentsIdDropPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiClassEnrollmentsIdDropPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiClassEnrollmentsIdProcessingTaskGetRaw(requestParameters: ApiClassEnrollmentsIdProcessingTaskGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiClassEnrollmentsIdProcessingTaskGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/{id}/processing-task`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiClassEnrollmentsIdProcessingTaskGet(requestParameters: ApiClassEnrollmentsIdProcessingTaskGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiClassEnrollmentsIdProcessingTaskGetRaw(requestParameters, initOverrides);
    }

    /**
     * Used by administrators to reject a pending enrollment request, marking it as rejected in the system.
     * Reject an enrollment
     */
    async apiClassEnrollmentsIdRejectPutRaw(requestParameters: ApiClassEnrollmentsIdRejectPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiClassEnrollmentsIdRejectPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/{id}/reject`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by administrators to reject a pending enrollment request, marking it as rejected in the system.
     * Reject an enrollment
     */
    async apiClassEnrollmentsIdRejectPut(requestParameters: ApiClassEnrollmentsIdRejectPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiClassEnrollmentsIdRejectPutRaw(requestParameters, initOverrides);
    }

    /**
     * Clear enrollment review presence
     */
    async apiClassEnrollmentsIdReviewPresenceDeleteRaw(requestParameters: ApiClassEnrollmentsIdReviewPresenceDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiClassEnrollmentsIdReviewPresenceDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/{id}/review-presence`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Clear enrollment review presence
     */
    async apiClassEnrollmentsIdReviewPresenceDelete(requestParameters: ApiClassEnrollmentsIdReviewPresenceDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiClassEnrollmentsIdReviewPresenceDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Heartbeat enrollment review presence
     */
    async apiClassEnrollmentsIdReviewPresencePutRaw(requestParameters: ApiClassEnrollmentsIdReviewPresencePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiClassEnrollmentsIdReviewPresencePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/{id}/review-presence`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Heartbeat enrollment review presence
     */
    async apiClassEnrollmentsIdReviewPresencePut(requestParameters: ApiClassEnrollmentsIdReviewPresencePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiClassEnrollmentsIdReviewPresencePutRaw(requestParameters, initOverrides);
    }

    /**
     * Allows a parent, student, or administrator to request that an active enrollment be dropped on a future date.
     * Schedule a future drop for an active enrollment
     */
    async apiClassEnrollmentsIdScheduledDropPutRaw(requestParameters: ApiClassEnrollmentsIdScheduledDropPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiClassEnrollmentsIdScheduledDropPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/{id}/scheduled-drop`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DropEnrollmentRequestToJSON(requestParameters['dropEnrollmentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Allows a parent, student, or administrator to request that an active enrollment be dropped on a future date.
     * Schedule a future drop for an active enrollment
     */
    async apiClassEnrollmentsIdScheduledDropPut(requestParameters: ApiClassEnrollmentsIdScheduledDropPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiClassEnrollmentsIdScheduledDropPutRaw(requestParameters, initOverrides);
    }

    /**
     * Open enrollments a parent started themselves, or those marked done today. Withdrawals stay on the withdrawals queue.
     * Parent enrollment reviews inbox
     */
    async apiClassEnrollmentsParentReviewsGetRaw(requestParameters: ApiClassEnrollmentsParentReviewsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ParentEnrollmentReviewItem>>> {
        const queryParameters: any = {};

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/parent-reviews`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ParentEnrollmentReviewItemFromJSON));
    }

    /**
     * Open enrollments a parent started themselves, or those marked done today. Withdrawals stay on the withdrawals queue.
     * Parent enrollment reviews inbox
     */
    async apiClassEnrollmentsParentReviewsGet(requestParameters: ApiClassEnrollmentsParentReviewsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ParentEnrollmentReviewItem>> {
        const response = await this.apiClassEnrollmentsParentReviewsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enrollment activity recorded in the last N studio calendar days (default 7, max 30). changedAt is when the change was recorded. dropDate is the effective withdraw day after a withdrawal is approved or has taken effect. A parent request still waiting for approval has no dropDate.
     * Recent enrollment status changes
     */
    async apiClassEnrollmentsRecentStatusChangesGetRaw(requestParameters: ApiClassEnrollmentsRecentStatusChangesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RecentEnrollmentStatusChangeItem>>> {
        const queryParameters: any = {};

        if (requestParameters['days'] != null) {
            queryParameters['days'] = requestParameters['days'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/recent-status-changes`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RecentEnrollmentStatusChangeItemFromJSON));
    }

    /**
     * Enrollment activity recorded in the last N studio calendar days (default 7, max 30). changedAt is when the change was recorded. dropDate is the effective withdraw day after a withdrawal is approved or has taken effect. A parent request still waiting for approval has no dropDate.
     * Recent enrollment status changes
     */
    async apiClassEnrollmentsRecentStatusChangesGet(requestParameters: ApiClassEnrollmentsRecentStatusChangesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RecentEnrollmentStatusChangeItem>> {
        const response = await this.apiClassEnrollmentsRecentStatusChangesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cursor-paged class enrollments where the student is active. Replaces client-side student scroll + batched enrollment fetches for dashboard loads.
     * Scroll enrollments for active students
     */
    async apiClassEnrollmentsScrollGetRaw(requestParameters: ApiClassEnrollmentsScrollGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetEnrollmentResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/scroll`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetEnrollmentResponseFromJSON(jsonValue));
    }

    /**
     * Cursor-paged class enrollments where the student is active. Replaces client-side student scroll + batched enrollment fetches for dashboard loads.
     * Scroll enrollments for active students
     */
    async apiClassEnrollmentsScrollGet(requestParameters: ApiClassEnrollmentsScrollGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetEnrollmentResponse> {
        const response = await this.apiClassEnrollmentsScrollGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get enrollments for multiple students
     * Get enrollments by Students
     */
    async apiClassEnrollmentsStudentsGetRaw(requestParameters: ApiClassEnrollmentsStudentsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetEnrollmentResponse>> {
        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/students`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetEnrollmentResponseFromJSON(jsonValue));
    }

    /**
     * Get enrollments for multiple students
     * Get enrollments by Students
     */
    async apiClassEnrollmentsStudentsGet(requestParameters: ApiClassEnrollmentsStudentsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetEnrollmentResponse> {
        const response = await this.apiClassEnrollmentsStudentsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get enrollments for a single student
     * Get enrollments by Student
     */
    async apiClassEnrollmentsStudentsIdGetRaw(requestParameters: ApiClassEnrollmentsStudentsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetEnrollmentResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiClassEnrollmentsStudentsIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/students/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetEnrollmentResponseFromJSON(jsonValue));
    }

    /**
     * Get enrollments for a single student
     * Get enrollments by Student
     */
    async apiClassEnrollmentsStudentsIdGet(requestParameters: ApiClassEnrollmentsStudentsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetEnrollmentResponse> {
        const response = await this.apiClassEnrollmentsStudentsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get enrollment
     */
    async getEnrollmentByIdRaw(requestParameters: GetEnrollmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEnrollmentResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getEnrollmentById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-enrollments/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEnrollmentResponseFromJSON(jsonValue));
    }

    /**
     * Get enrollment
     */
    async getEnrollmentById(requestParameters: GetEnrollmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEnrollmentResponse> {
        const response = await this.getEnrollmentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
